// src/layout/ClientPortalLayout.jsx
import React, { useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import { CContainer, CNavbar, CNavbarBrand } from "@coreui/react";
import logoStream from "assets/brand/logo_stream.png";

const NAVBAR_HEIGHT = 72;

const ClientLayout = () => {
  const [clientBranding, setClientBranding] = useState({
    name: "",
    logo: "",
  });

  const outletContext = useMemo(
    () => ({ clientBranding, setClientBranding }),
    [clientBranding]
  );

  return (
    <div
      className="bg-light min-vh-100 d-flex flex-column"
      style={{ "--client-navbar-height": `${NAVBAR_HEIGHT}px` }}
    >
      {/* Barra superior simples */}
      <CNavbar
        colorScheme="light"
        className="bg-white shadow-sm py-2"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 800,
          minHeight: NAVBAR_HEIGHT,
          borderBottom: "1px solid rgba(0,0,0,0.05)",
        }}
      >
        <CContainer fluid>
          <div className="d-flex align-items-center w-100 px-5">
            <CNavbarBrand className="d-flex align-items-center gap-3 me-auto">
              <img
                src={logoStream}
                alt="STREAM/"
                style={{ height: 36, width: "auto" }}
              />
              <div className="d-flex flex-column lh-1">
                <span className="fw-semibold text-dark">Portal do Cliente</span>
                <small className="text-muted">Gestão de Projetos</small>
              </div>
            </CNavbarBrand>

            <div className="d-flex align-items-center ms-auto gap-2">
              {clientBranding?.logo ? (
                <img
                  src={clientBranding.logo}
                  alt={clientBranding?.name || "Cliente"}
                  style={{ height: 55, width: "auto", objectFit: "contain" }}
                />
              ) : clientBranding?.name ? (
                <span className="fw-semibold text-muted">
                  {clientBranding.name}
                </span>
              ) : null}
            </div>
          </div>
        </CContainer>
      </CNavbar>

      {/* Conteúdo central */}
      <CContainer
        fluid
        className="flex-grow-1 d-flex justify-content-center align-items-start py-4"
        style={{ paddingTop: "1.5rem" }}
      >
        <div style={{ width: "100%", maxWidth: "1200px" }}>
          <Outlet context={outletContext} />
        </div>
      </CContainer>

      <footer
        className="py-3 text-center text-muted"
        style={{ fontSize: "0.75rem" }}
      >
        © {new Date().getFullYear()} STREAM/ · Portal do Cliente
      </footer>
    </div>
  );
};

export default ClientLayout;
